import { getVersion, Version_Read } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useEffect, useState } from 'react';

import connection from '~services/connectionModule';

const EMPTY_VERSION: Version_Read = { sha: '', time: '' };

export default function useVersion() {
  const [version, setVersion] = useState<Version_Read>(EMPTY_VERSION);

  const getCurrentVersion = async () => {
    try {
      const response = await getVersion();
      const versionData = response.data.data;
      setVersion(versionData);

      return versionData;
    } catch (error) {
      try {
        connection.handleRequestError(error, t('error_messages.version.failed_to_fetch'));
      } catch {
        // Error already handled via toaster + Sentry.
      }

      return undefined;
    }
  };

  useEffect(() => {
    void getCurrentVersion();
  }, []);

  return { version };
}
